interface SortThProps {
  field: string;
  sortBy: string;
  sortDir: 'asc' | 'desc';
  onSort: (field: string) => void;
  children: React.ReactNode;
  className?: string;
}

export default function SortTh({ field, sortBy, sortDir, onSort, children, className }: SortThProps) {
  const active = sortBy === field;
  return (
    <th
      className={`px-3 py-3 text-left text-xs font-medium uppercase cursor-pointer select-none group ${active ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'} ${className ?? ''}`}
      onClick={() => onSort(field)}
    >
      <span className="inline-flex items-center gap-1">
        {children}
        <span className={`text-sm ${active ? 'text-gray-800' : 'text-gray-400 group-hover:text-gray-600'}`}>
          {active ? (sortDir === 'asc' ? '↑' : '↓') : '↕'}
        </span>
      </span>
    </th>
  );
}
